export default __webpack_public_path__ + "static/media/ride-green.208301f7.svg";